import { render, staticRenderFns } from "./WBGDMOFX.vue?vue&type=template&id=54161b08&scoped=true"
import script from "./WBGDMOFX.vue?vue&type=script&lang=js"
export * from "./WBGDMOFX.vue?vue&type=script&lang=js"
import style0 from "./WBGDMOFX.vue?vue&type=style&index=0&id=54161b08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54161b08",
  null
  
)

export default component.exports